<template>
  <div class="sm:flex-row relative flex flex-col">
    <FixedAspect v-for="(image, idx) in images" :key="idx" :ratio="0.55" class="sm:hidden">
      <CldnImg
        :src="image.url"
        :alt="image.title"
        sizes="100vw sm:50vw md:50vw lg:50vw xl:50vw 2xl:50vw"
        crop="fill"
        class="max-w-none absolute inset-0 z-0 block object-cover w-full h-full"
      />
    </FixedAspect>
    <FixedAspect v-for="(image, idx) in images" :key="`horizontal-${idx}`" :ratio="0.85" class="sm:block hidden w-1/2">
      <CldnImg
        :src="image.url"
        :alt="image.title"
        sizes="100vw sm:50vw md:50vw lg:50vw xl:50vw 2xl:50vw"
        crop="fill"
        class="max-w-none absolute inset-0 z-0 block object-cover w-full h-full"
      />
    </FixedAspect>
    <div class="absolute inset-0 z-10 flex flex-row items-center justify-start">
      <BarText :text="heading" tag="h3" class="fluid-4xl leading-none ml-2" />
    </div>
  </div>
</template>

<script>
import CldnImg from '@/components/CldnImg';
import FixedAspect from '@/components/common/FixedAspect';
import BarText from '@/components/BarText.vue';
import gql from 'graphql-tag';

export default defineNuxtComponent({
  components: {
    CldnImg,
    FixedAspect,
    BarText,
  },
  props: {
    images: {
      type: Array,
      default: () => [],
    },
    heading: {
      type: String,
      default: '',
    },
  },
});
</script>
